import React, { useState } from 'react';
import styled, { StylesProps, useStyles } from '../../../../../lib/styles';
import menuTileBlockStyles from './MenuTileBlock_styles';
import { opacity } from '../../../../../lib/colourUtilities';
import Icon from '../../../../../components/presentational/Icon';
import ResponsiveRender from '../../../../../behaviour/ResponsiveRender';

//#region Props and Types
interface MenuTileItem {
  title: string;
  excerpt: string;
	background_image: string;
	background_colour: string;
	text_colour: string;
	links: { 
		id: number;
		title: string;
		href: string;
	}[],
};

export interface MenuTileBlockData {
  type: 'menu_tile_block';
  menu_items: MenuTileItem[];
}

export interface MenuTileBlockProps {
  block: MenuTileBlockData;
}

interface RenderMenuLinksProps {
  menu_item: MenuTileItem;
}

interface RenderCardProps {
	isMobile: boolean;
};
//#endregion Props and Types

const RenderMenuTileLinks = ({ 
	menu_item,
}: RenderMenuLinksProps) => {
	console.log('RenderMenuTileLinks', { menu_item });
	const styles = useStyles(menuTileBlockStyles());

	return (
		<div className={`links ${styles.links}`}>
			{menu_item.links.map((link, i) => {
				return (
					<div
						key={i}
						className={`menuItemLink ${styles.menuItemLink}`}
					>
						<a href={link.href}>
							{link.title}
						</a>
						<Icon icon={'chevron_right'} />
					</div>
				)
			})}
		</div>
	);
}

const RenderCard = ({
	block: 
		{ 
			menu_items,
		},
	isMobile,
	styles
}: MenuTileBlockProps & RenderCardProps & StylesProps<typeof menuTileBlockStyles>) => {
	const [showLinksForTileKey, setShowLinksForTileKey] = useState<number | null>(0);
	return (
		<div 
			className={`menuTileContainer ${styles.menuTileContainer} ${isMobile ? 'flex-column' : ''}`}
		>
			{menu_items
				.map((menu_item: MenuTileItem, key) => {
					// console.log({ menu_item }, 'MenuTileBlock');
					const { title, excerpt, background_image, background_colour, text_colour } = menu_item;
					return (
						<div 
							key={key} 
							className={`menuTile ${styles.menuTile} ${showLinksForTileKey === key ? 'showLinks' : ''}`}
							style={{ backgroundColor: background_colour }}
							onClick={() => {
								setShowLinksForTileKey(key);
							}}
						>
							<div className={`bgImage ${styles.bgImage}`}
								style={{ backgroundImage: `url(${background_image}?w=500)`}}
							/>
							<div className={`bgColour ${styles.bgColour}`}
								style={{
									background: `${opacity(background_colour, 50)}`, 
								}}
							>
								<div className={`menuTileContent ${styles.menuTileContent}`}>
									<h2 
										className={`menuTileTitle ${styles.menuTileTitle}`}
										style={{
											color: text_colour,
										}}
									>
										{title}
									</h2>
									<p 
										className={`menuTileExcerpt ${styles.menuTileExcerpt}`}
										style={{
											color: text_colour,
										}}
									>
										{excerpt}
									</p>
								</div>

								<RenderMenuTileLinks menu_item={menu_item} />
							</div>
						</div>
					)
				})
			}
		</div>
	)
};

const MenuTileBlock = ({ 
	block, 
	styles
}: MenuTileBlockProps & StylesProps<typeof menuTileBlockStyles>) => {
	const { menu_items } = block;
	// console.log('MenuTileBlock', { block });
  return (
    <div className={`menutile-block ${styles.container}`}>
			<>
				<ResponsiveRender match={'s'} up>
					<RenderCard block={block} styles={styles} isMobile={false} />
				</ResponsiveRender>

				<ResponsiveRender match={'s'}>
					<RenderCard block={block} styles={styles} isMobile={true} />
				</ResponsiveRender>
			</>
		</div>
	);
};

export default styled(menuTileBlockStyles)(MenuTileBlock);